import { useEffect, useState } from "react";
import {
  Container,
  ViewModal,
  ViewTextInput,
  ViewButton,
  ContentIcon,
  ViewDescription,
} from "./style";
import Footer from "../../components/Footer";
import {
  collection,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { useAuthUser } from "../../contexts/useAuthUser";
import {
  SubTitle,
  SmallText,
  FooterText,
} from "../../config/theme/globalStyles";
import { firestore } from "../../services/firebase/index";
import THEME from "../../config/theme";
import Button from "../../components/Button";
// import { Cookie } from "../../components/CookieConsent";
import { View, ScrollView, Modal, TouchableOpacity, Image } from "react-native";
import { ActivityIndicator, HelperText, Switch } from "react-native-paper";
import ViewPortProvider from "../../hooks/ViewPortProvider";
import { Provider } from "react-native-paper";
import TextInput from "../../components/TextInput";
import { AlertBox } from "../../components/AlertBox";
import { AntDesign } from "@expo/vector-icons";
import CurrencyInput from "react-native-currency-input";
import { getFunctions, httpsCallable } from "firebase/functions";
import Constants from "expo-constants";
import PageSection from "../../components/Section";
import { clientConfig } from '../../config/theme/sectionsStyles';
import { footerSocialData } from '../../config/data';
import { Linking } from 'react-native';

const { projectId } = Constants.manifest.extra;

const functions = getFunctions();

const whatsappInfo = footerSocialData.find(obj => obj.name === "whatsapp");
const whatsappURL = whatsappInfo?.link || '';

const openWhatsApp = () => {
  if (whatsappURL) {
    Linking.openURL(whatsappURL);
  } else {
    console.error('A URL do WhatsApp não está definida ou é inválida.');
  }
};

export function About() {
  const { user, isLogged, userId: authUserId } = useAuthUser();
  const userId = isLogged ? authUserId : "";
  const [course, setCourse] = useState({ infos: [""] });
  const {
    infos,
  } = course;

  const [plan, setPlan] = useState("");
  const [coursesInfo, setCoursesInfo] = useState([]);
  const [plansInfo, setPlansInfo] = useState([]);
  const [firstPlanPurchase, setFirstPlanPurchase] = useState(true);
  const [planFrequency, setPlanFrequency] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [titleCourse, setTitleCourse] = useState({ value: "", error: "" });
  const [priceCourse, setPriceCourse] = useState({ value: "", error: "" });
  const [priceCourseStripe, setPriceCourseStripe] = useState();
  const [valueCourseWithRS, setValueCourseWithRS] = useState("");
  const [smallText, setSmallText] = useState("");
  const [validityCourse, setValidityCourse] = useState({ value: "", error: "" });

  const [salesPageUrl, setSalesPageUrl] = useState("");

  const [youtube, setYoutube] = useState({ value: "", error: "" });
  const [loadingSave, setLoadingSave] = useState(false);

  const [visibleAlert, setVisibleAlert] = useState(false);
  const [message, setMessege] = useState(null);


  const getCourses = async (isAdmin) => {
    const response = await getDocs(collection(firestore, "courses"));
    let courses = [];
    if (response.docs.length == 0) return setIsLoading(false)

    response.forEach((doc) => {
      if (isAdmin) {
        courses.push({ id: doc.id, ...doc.data() });
      } else {
        if (doc.data().archived == false && !doc.data().invisibleAbout) {
          courses.push({ id: doc.id, ...doc.data() });
        }
      }
    });
    setCoursesInfo(courses);
    setIsLoading(false);
  };

  const getPlans = async () => {
    const response = await getDocs(
      query(collection(firestore, "plans"), orderBy("order", "asc"))
    );
    let plans = [];
    let frequency = [];
    if (response.docs.length == 0) return setIsLoading(false)

    response.forEach((doc) => {
      const data = doc.data();
      if (data.isPlanFrequency == false && data.archived == false) {
        plans.push({ id: doc.id, ...data });
      } else if (data.isPlanFrequency == true) {
        frequency.push(data.planFrequency);
      }
    });
    setPlansInfo(plans);
    setPlanFrequency(frequency[0]);
    setIsLoading(false);
  };

  const showAlert = (message) => {
    setVisibleAlert(true);
    setMessege(message);
  };

  const hideAlert = (status) => {
    setVisibleAlert(status);
  };

  // O usuário já vem resolvido do boot, então a lista de cursos é buscada uma
  // vez só com a visibilidade certa — antes era buscada como visitante e
  // refeita quando o `onAuthStateChanged` desta tela respondia.
  useEffect(() => {
    if (user?.firstPlanPurchase === false) {
      setFirstPlanPurchase(user.firstPlanPurchase);
    }
    setPlan(user?.plan);
    getCourses(!!user?.isAdmin);
    getPlans();
  }, [user]);

  if (isLoading) {
    return (
      <ActivityIndicator
        style={{
          flex: 1,
          backgroundColor: THEME.COLORS.BACKGROUND_ABOUT,
          justifyContent: "center",
        }}
        color={THEME.COLORS.PRIMARY_800}
      />
    );
  }

  const client = clientConfig.find((client) => client.name === projectId);
  const pageName = client?.pages.find((page) => page.name === "about");

  return (
    <Provider>
      <Container>
        <ViewPortProvider>
          <View>
            {pageName?.sections.map((section, index) => {
              // Check if the section has the 'coursesCards' component
              const hasCoursesCards =
                section.columns &&
                section.columns.some((column) =>
                  column.items.some((item) => item.type === 'coursesCards')
                );

              // Render the section if it doesn't have 'coursesCards' or if 'coursesCards.length > 0 and hasCoursesCards'
              if (!hasCoursesCards || (hasCoursesCards && coursesInfo.length > 0) || (hasCoursesCards && user?.isAdmin)) {
                return (
                  <PageSection
                    key={`${projectId}-section-${index}`}
                    client={client}
                    pageName={pageName}
                    sectionIndex={index}
                    userId={userId}
                    user={user}
                    firstPlanPurchase={firstPlanPurchase}
                    plan={plan}
                    isAdmin={user?.isAdmin}
                    coursesInfo={coursesInfo}
                    planFrequency={planFrequency}
                    plansInfo={plansInfo}
                    handleOnPressButton={() => setVisible1(true)}
                  />
                );
              } else {
                return null;
              }
            })}
          </View>
        </ViewPortProvider>
        <View>
          <Footer></Footer>
        </View>
      </Container>
      {whatsappURL &&
        <TouchableOpacity
          onPress={openWhatsApp}
          style={{ position: 'absolute', bottom: 40, right: 20 }}
        >
          <Image
            source={require('../../../assets/whatsapp-logo.svg')}
            style={{ width: 50, height: 50 }}
          />
        </TouchableOpacity>
      }
      
      {visibleAlert && (
        <AlertBox
          message={message}
          visible={visibleAlert}
          onClose={hideAlert}
          leftButtonFunction={hideAlert}
          leftButton={"OK"}
        ></AlertBox>
      )}
    </Provider>
  )
}
